// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import dayjs from "dayjs";
// import moment from "moment";
// import {
//   Layout,
//   Button,
//   Select,
//   Tabs,
//   Card,
//   Row,
//   Col,
//   Table,
//   Modal,
//   Input,
//   InputNumber,
//   DatePicker,
//   Tag,
//   Progress,
//   Empty,
//   Space,
//   message,
//   Upload,
//   Image,
//   Tooltip,
//   Typography 
// } from "antd";
// import {
//   getCaisses,
//   getDepartements,
//   getModesPaiement,
//   getDashboard,
//   getMouvements,
//   createMouvement,
//   deleteMouvement,
//   createDepartement,
//   deleteDepartement,
//   addpj,
//   exportMouvements as exportMouvementsApi,
//   exportMouvementPj,
//   getCategories,
//   createCategorie,
//   deleteCategorie,
// } from "../../api/caisseapi";
// import {
//   UploadOutlined,
//   PaperClipOutlined,
//   CameraOutlined,
//   DeleteOutlined,
//   FileImageOutlined,
//   DownloadOutlined,
//   ArrowUpOutlined,
//   ArrowDownOutlined,
//   CalendarOutlined,
//   BankOutlined,
//   WalletOutlined,
//   SwapOutlined,
//   CreditCardOutlined,
//   MobileOutlined,
//   FileTextOutlined,
// } from "@ant-design/icons";

// const { Header, Content } = Layout;

// const TYPES_MOUVEMENT = [
//   { value: "depense", label: "Dépense" },
//   { value: "recette", label: "Recette" },
// ];

// const fmt = (n) =>
//   new Intl.NumberFormat("fr-MG", { maximumFractionDigits: 0 }).format(n || 0) +
//   " Ar";
// const toDate = (d) => (d instanceof Date ? d : new Date(d));
// const fmtDate = (d) =>
//   toDate(d).toLocaleDateString("fr-FR", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// const fmtDateInput = (d) => toDate(d).toISOString().slice(0, 10);
// const monthLabel = (d) =>
//   d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

// function SoldeAreaChart({ data }) {
//   if (!data.length) return <Empty description="Pas de données" />;
//   const width = 600,
//     height = 200,
//     pad = 10;
//   const values = data.map((d) => d.solde);
//   const min = Math.min(...values),
//     max = Math.max(...values);
//   const span = max - min || 1;
//   const pts = data.map((d, i) => {
//     const x = pad + (i / Math.max(data.length - 1, 1)) * (width - 2 * pad);
//     const y = height - pad - ((d.solde - min) / span) * (height - 2 * pad);
//     return [x, y];
//   });
//   const line = pts
//     .map((p, i) => (i === 0 ? "M" : "L") + p[0] + "," + p[1])
//     .join(" ");
//   const area =
//     line +
//     ` L${pts[pts.length - 1][0]},${height - pad} L${pts[0][0]},${height - pad} Z`;
//   const last = pts[pts.length - 1];
//   return (
//     <svg
//       viewBox={`0 0 ${width} ${height}`}
//       style={{ width: "100%", height: "auto", display: "block" }}
//     >
//       <defs>
//         <linearGradient id="soldeGrad" x1="0" y1="0" x2="0" y2="1">
//           <stop offset="0%" stopColor="#1677ff" stopOpacity="0.25" />
//           <stop offset="100%" stopColor="#1677ff" stopOpacity="0" />
//         </linearGradient>
//       </defs>
//       <path d={area} fill="url(#soldeGrad)" stroke="none" />
//       <path d={line} fill="none" stroke="#1677ff" strokeWidth="2" />
//       <circle cx={last[0]} cy={last[1]} r="4" fill="#1677ff" />
//     </svg>
//   );
// }

// const GLOBAL_STYLES = `
//   /* Le conteneur hôte (index.html) limite parfois déjà html/body en
//      hauteur avec overflow:hidden pour faire des layouts "app-like".
//      On neutralise ça ici et on gère nous-mêmes un seul niveau de scroll,
//      pour être sûr que tout le contenu (tableaux, pagination, formulaires)
//      reste atteignable quelle que soit la hauteur de l'écran. */
//   html, body, #root { height: 100%; }

//   .caisse-app {
//     background:#f5f7fb;
//     font-family: -apple-system, "Segoe UI", Inter, sans-serif;
//     height: 100vh;
//     max-height: 100vh;
//     overflow: hidden;
//     display: flex;
//     flex-direction: column;
//   }

//   /* Seule cette zone défile : le header reste visible, tout le reste
//      (KPI, graphiques, tableaux + leur pagination, formulaires) devient
//      accessible en scrollant, même sur un écran bas (12 pouces ~768px). */
//   .app-scroll {
//     flex: 1 1 auto;
//     min-height: 0; /* indispensable dans un flex column pour autoriser le scroll interne */
//     overflow-y: auto;
//     overflow-x: hidden;
//     -webkit-overflow-scrolling: touch;
//   }
//   .kpi-icon { width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0; }
//   .app-header { background:#fff;border-bottom:1px solid #e8ecf3; flex-shrink:0; }
//   .brand-badge { width:36px;height:36px;border-radius:8px;background:#1677ff;color:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
//   .dept-swatch { width:36px;height:36px;border-radius:8px;color:#fff;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:600;flex-shrink:0; }
//   .movement-search .ant-input-affix-wrapper { border-radius:8px; }
//   .ant-tabs-tab { font-weight:500; }
//   .app-shell { max-width:1400px; margin:0 auto; width:100%; box-sizing:border-box; }

//   /* Le contenu des tableaux ne doit jamais être coupé silencieusement :
//      on force toujours un scroll horizontal interne au composant Table
//      plutôt que de laisser les colonnes déborder de la carte. */
//   .ant-table-wrapper { width:100%; overflow-x:auto; }
//   .ant-table { min-width: 100%; }

//   /* Zone de rattachement de pièces jointes : deux gros boutons tactiles
//      (photo / fichiers) qui restent confortables au doigt sur mobile. */
//   .attach-actions { display:flex; gap:10px; flex-wrap:wrap; }
//   .attach-actions .ant-btn { flex:1 1 160px; height:44px; }
//   .attach-preview-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(84px,1fr)); gap:10px; margin-top:14px; }
//   .attach-preview-item { position:relative; border:1px solid #e8ecf3; border-radius:8px; overflow:hidden; aspect-ratio:1/1; background:#f5f7fb; }
//   .attach-preview-item img { width:100%; height:100%; object-fit:cover; display:block; }
//   .attach-preview-remove { position:absolute; top:4px; right:4px; background:rgba(0,0,0,0.55); border:none; color:#fff; width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; cursor:pointer; font-size:12px; line-height:1; }
//   .attach-preview-name { font-size:10px; color:#fff; background:rgba(0,0,0,0.55); position:absolute; bottom:0; left:0; right:0; padding:2px 4px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }

//   /* Écrans <= 1366px (13 pouces et moins, dont la plupart des 12 pouces) */
//   @media (max-width: 1366px) {
//     .app-shell { padding-left:16px !important; padding-right:16px !important; }
//     .app-header { padding-left:16px; padding-right:16px; }
//   }

//   /* Écrans <= 991px : le header passe en colonne pour ne jamais tronquer
//      le sélecteur de caisse ou le bouton "Nouveau mouvement". */
//   @media (max-width: 991px) {
//     .app-header {
//       height:auto !important;
//       flex-direction:column;
//       align-items:stretch !important;
//       gap:12px;
//       padding-top:12px;
//       padding-bottom:12px;
//     }
//     .app-header .header-actions { width:100%; }
//     .app-header .header-actions .ant-select { width:100% !important; }
//     .app-header .header-actions .ant-btn { width:100%; }
//   }

//   /* Écrans <= 576px : ajustements fins pour mobile / petites tablettes */
//   @media (max-width: 576px) {
//     .kpi-icon { width:34px;height:34px;font-size:16px; }
//     .app-shell { padding-left:10px !important; padding-right:10px !important; }
//   }
// `;
// const PALETTE = ["geekblue", "purple", "cyan", "magenta", "volcano", "gold", "lime"];
// const colorFromText = (txt = "") => {
//   let h = 0;
//   for (const c of String(txt)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
//   return PALETTE[h % PALETTE.length];
// };

// const MODE_META = {
//   espèces: { color: "green", icon: <WalletOutlined /> },
//   especes: { color: "green", icon: <WalletOutlined /> },
//   chèque: { color: "orange", icon: <FileTextOutlined /> },
//   cheque: { color: "orange", icon: <FileTextOutlined /> },
//   virement: { color: "blue", icon: <BankOutlined /> },
//   carte: { color: "purple", icon: <CreditCardOutlined /> },
//   mobile: { color: "cyan", icon: <MobileOutlined /> },
// };
// const modeMeta = (m) =>
//   MODE_META[String(m || "").toLowerCase()] || { color: "default", icon: <SwapOutlined /> };

// export default function CaissePreview() {
//   const [tab, setTab] = useState("dashboard");
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [caisses, setCaisses] = useState([]);
//   const [caisseId, setCaisseId] = useState(null);
//   const [agenceId, setAgenceId] = useState(null);
//   const [departements, setDepartements] = useState([]);
//   const [modesPaiement, setModesPaiement] = useState([]);
//   const [refLoading, setRefLoading] = useState(true);


//   useEffect(() => {
//     (async () => {
//       try {
//         const [caissesRes, deptRes, modesRes] = await Promise.all([
//           getCaisses(),
//           getDepartements(),
//           getModesPaiement(),
//         ]);
//         setCaisses(caissesRes.data);
//         setDepartements(deptRes.data);
//         setModesPaiement(modesRes.data);
//         console.log(caissesRes.data.length, caissesRes.data[0].id);
//         if (caissesRes.data.length) setCaisseId(caissesRes.data[0].id);
//         if (caissesRes.data.length) setAgenceId(caissesRes.data[0].agence_id);
//       } catch (e) {
//         message.error(
//           e.message || "Erreur lors du chargement des données de référence",
//         );
//       } finally {
//         setRefLoading(false);
//       }
//     })();
//   }, []);

//   const caisse = caisses.find((c) => c.id === caisseId);

//   return (
//     <Layout className="caisse-app">
//       <style>{GLOBAL_STYLES}</style>

//       <Header
//         className="app-header px-3 d-flex align-items-center justify-content-between"
//         style={{ height: 64, lineHeight: "normal" }}
//       >
//         <div className="d-flex align-items-center gap-2">
//           <div className="brand-badge">
//             <i className="bi bi-bank2"></i>
//           </div>
//           <div>
//             <div style={{ fontSize: 15, fontWeight: 600, color: "#1f2430" }}>
//               Gestion de Caisse
//             </div>
//             <div className="text-secondary" style={{ fontSize: 12 }}>
//               Suivi interne des mouvements
//             </div>
//           </div>
//         </div>
//         <div className="header-actions d-flex align-items-center gap-2 flex-wrap">
//           <Select
//             loading={refLoading}
//             value={caisseId}
//             onChange={setCaisseId}
//             style={{ width: 220, maxWidth: "100%" }}
//             options={caisses.map((c) => ({ value: c.id, label: c.nom }))}
//             placeholder="Sélectionner une caisse"
//           />
//           <Button
//             type="primary"
//             disabled={!caisseId}
//             icon={<i className="bi bi-plus-lg me-1"></i>}
//             onClick={() => setShowAddModal(true)}
//           >
//             Nouveau mouvement
//           </Button>
//         </div>
//       </Header>

//       <div className="app-scroll">
//         <div className="app-shell w-100 px-3">
//           <Tabs
//             activeKey={tab}
//             onChange={setTab}
//             items={[
//               {
//                 key: "dashboard",
//                 label: (
//                   <span>
//                     <i className="bi bi-grid-1x2 me-1"></i>Tableau de bord
//                   </span>
//                 ),
//               },
//               {
//                 key: "mouvements",
//                 label: (
//                   <span>
//                     <i className="bi bi-funnel me-1"></i>Mouvements
//                   </span>
//                 ),
//               },
//               {
//                 key: "departements",
//                 label: (
//                   <span>
//                     <i className="bi bi-building me-1"></i>Départements
//                   </span>
//                 ),
//               },
//             ]}
//           />

//           <Content className="pb-5">
//             {!caisseId ? (
//               <Empty
//                 className="pt-5"
//                 description={
//                   refLoading ? "Chargement..." : "Aucune caisse disponible"
//                 }
//               />
//             ) : (
//               <>
//                 {tab === "dashboard" && (
//                   <DashboardTab
//                     caisseId={caisseId}
//                     caisseNom={caisse ? caisse.nom : ""}
//                     refreshKey={refreshKey}
//                   />
//                 )}
//                 {tab === "mouvements" && (
//                   <MouvementsTab
//                     caisseId={caisseId}
//                     departements={departements}
//                     modesPaiement={modesPaiement}
//                     refreshKey={refreshKey}
//                   />
//                 )}
//                 {tab === "departements" && (
//                   <DepartementsTab
//                     caisseId={caisseId}
//                     departements={departements}
//                     setDepartements={setDepartements}
//                     agence_id={agenceId}
//                     onDeptChanged={() => setRefreshKey((k) => k + 1)}
//                   />
//                 )}
//               </>
//             )}
//           </Content>
//         </div>
//       </div>

//       {showAddModal && (
//         <AddMovementModal
//           caisseId={caisseId}
//           departements={departements}
//           modesPaiement={modesPaiement}
//           onClose={() => setShowAddModal(false)}
//           onSaved={() => {
//             setShowAddModal(false);
//             // Déclenche le refetch du dashboard + de la liste des mouvements,
//             // sans avoir besoin de recharger la page.
//             setRefreshKey((k) => k + 1);
//           }}
//         />
//       )}
//     </Layout>
//   );
// }

// // ---------------------------------------------------------------------
// // Dashboard
// // ---------------------------------------------------------------------

// function Kpi({ icon, label, value, tone }) {
//   const tones = {
//     blue: { bg: "#eaf2ff", color: "#1677ff" },
//     green: { bg: "#e9f9ef", color: "#16a34a" },
//     red: { bg: "#fdeeee", color: "#dc2626" },
//     slate: { bg: "#f1f3f7", color: "#475569" },
//   };
//   const t = tones[tone];
//   return (
//     <Card size="small">
//       <div className="d-flex align-items-center gap-3">
//         <div className="kpi-icon" style={{ background: t.bg, color: t.color }}>
//           <i className={"bi " + icon}></i>
//         </div>
//         <div style={{ minWidth: 0 }}>
//           <div
//             className="text-secondary"
//             style={{ fontSize: 12, fontWeight: 500 }}
//           >
//             {label}
//           </div>
//           <div style={{ fontSize: 18, fontWeight: 600, whiteSpace: "nowrap" }}>
//             {value}
//           </div>
//         </div>
//       </div>
//     </Card>
//   );
// }

// function DashboardTab({ caisseId, caisseNom, refreshKey }) {
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState(null);

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await getDashboard(caisseId);
//       setData(res.data);
//     } catch (e) {
//       message.error(
//         e.message || "Erreur lors du chargement du tableau de bord",
//       );
//     } finally {
//       setLoading(false);
//     }
//     // refreshKey déclenche un rechargement après un ajout de mouvement/département
//     // ailleurs dans l'app, sans que caisseId n'ait changé.
//   }, [caisseId, refreshKey]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   if (loading || !data) {
//     return (
//       <div className="pt-5 text-center text-secondary">
//         Chargement du tableau de bord...
//       </div>
//     );
//   }

//   const { kpis, soldeSeries, depensesParDepartement, derniersMouvements } =
//     data;
//   const maxDepense = Math.max(1, ...depensesParDepartement.map((d) => d.total));

//   const columns = [
//     { title: "Date", dataIndex: "date", render: (d) => fmtDate(d), width: 110 },
//     { title: "Libellé", dataIndex: "libelle", ellipsis: true, width: 220 },
//     {
//       title: "Département",
//       dataIndex: "departement",
//       render: (v) => <Tag>{v}</Tag>,
//       width: 150,
//     },
//     {
//       title: "Solde",
//       dataIndex: "solde",
//       align: "right",
//       render: (v) => <b>{fmt(v)}</b>,
//       width: 150,
//     },
//   ];

//   return (
//     <div className="d-flex flex-column gap-3 pt-3">
//       <div>
//         <div style={{ fontSize: 16, fontWeight: 600 }}>{caisseNom}</div>
//         <div
//           className="text-secondary"
//           style={{ fontSize: 12, textTransform: "capitalize" }}
//         >
//           {monthLabel(new Date())}
//         </div>
//       </div>

//       <Row gutter={[16, 16]}>
//         <Col xs={12} sm={12} md={6}>
//           <Kpi
//             icon="bi-wallet2"
//             label="Solde actuel"
//             value={fmt(kpis.soldeActuel)}
//             tone="blue"
//           />
//         </Col>
//         <Col xs={12} sm={12} md={6}>
//           <Kpi
//             icon="bi-graph-up-arrow"
//             label="Recettes du mois"
//             value={fmt(kpis.recettes)}
//             tone="green"
//           />
//         </Col>
//         <Col xs={12} sm={12} md={6}>
//           <Kpi
//             icon="bi-graph-down-arrow"
//             label="Dépenses du mois"
//             value={fmt(kpis.depenses)}
//             tone="red"
//           />
//         </Col>
//         <Col xs={12} sm={12} md={6}>
//           <Kpi
//             icon="bi-list-check"
//             label="Mouvements ce mois"
//             value={kpis.count}
//             tone="slate"
//           />
//         </Col>
//       </Row>

//       <Row gutter={[16, 16]}>
//         <Col xs={24} lg={16}>
//           <Card
//             title="Évolution du solde"
//             size="small"
//             extra={
//               <span className="text-secondary" style={{ fontSize: 12 }}>
//                 Mois en cours
//               </span>
//             }
//           >
//             <SoldeAreaChart data={soldeSeries} />
//           </Card>
//         </Col>
//         <Col xs={24} lg={8}>
//           <Card
//             title="Dépenses par département"
//             size="small"
//             extra={
//               <span className="text-secondary" style={{ fontSize: 12 }}>
//                 Mois en cours
//               </span>
//             }
//           >
//             {depensesParDepartement.length === 0 && (
//               <Empty description="Aucune dépense" />
//             )}
//             {depensesParDepartement.map((d) => (
//               <div key={d.id} className="mb-2">
//                 <div
//                   className="d-flex justify-content-between"
//                   style={{ fontSize: 12 }}
//                 >
//                   <span>{d.nom}</span>
//                   <span className="text-secondary">{fmt(d.total)}</span>
//                 </div>
//                 <Progress
//                   percent={Math.round((d.total / maxDepense) * 100)}
//                   showInfo={false}
//                   strokeColor={d.couleur}
//                   size="small"
//                 />
//               </div>
//             ))}
//           </Card>
//         </Col>
//       </Row>

//       <Card title="Derniers mouvements" size="small">
//         <Table
//           dataSource={derniersMouvements}
//           columns={columns}
//           rowKey="id"
//           size="small"
//           pagination={false}
//           scroll={{ x: "max-content" }}
//         />
//       </Card>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------
// // Mouvements
// // ---------------------------------------------------------------------

// const today = new Date();
// const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
// const DEFAULT_FILTERS = {
//   from: fmtDateInput(firstOfMonth),
//   to: fmtDateInput(today),
//   departement_id: null,
//   mode_paiement_id: null,
//   type: null,
//   q: "",
//   page: 1,
// };

// function MouvementsTab({ caisseId, departements, modesPaiement, agence_id, refreshKey, }) {
//   const [filters, setFilters] = useState(DEFAULT_FILTERS);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [attachMvt, setAttachMvt] = useState(null);
//   const [downloadingId, setDownloadingId] = useState(null);
//   const [downloadingMonth, setDownloadingMonth] = useState(false);
//   const [exporting, setExporting] = useState(false);

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await getMouvements({
//         caisse_id: caisseId,
//         du: filters.from,
//         au: filters.to,
//         departement_id: filters.departement_id || undefined,
//         mode_paiement_id: filters.mode_paiement_id || undefined,
//         type: filters.type || undefined,
//         q: filters.q || undefined,
//         page: filters.page,
//         page_size: 10,
//       });
//       console.log(res.data);
//       setRows(res.data);
//       setTotal(res.pagination.total);
//     } catch (e) {
//       message.error(e.message || "Erreur lors du chargement des mouvements");
//     } finally {
//       setLoading(false);
//     }
//   }, [caisseId, filters]);

//   useEffect(() => {
//     const t = setTimeout(load, filters.q ? 350 : 0);
//     return () => clearTimeout(t);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     caisseId,
//     filters.from,
//     filters.to,
//     filters.departement_id,
//     filters.mode_paiement_id,
//     filters.type,
//     filters.page,
//     filters.q,
//     refreshKey, // recharge la liste après un ajout de mouvement ailleurs dans l'app
//   ]);

//   const setFilter = (patch) =>
//     setFilters((f) => ({ ...f, ...patch, page: patch.page ?? 1 }));

//   const handleDelete = async (id) => {
//     try {
//       await deleteMouvement(id);
//       message.success("Mouvement supprimé");
//       load();
//     } catch (e) {
//       message.error(e.message || "Erreur lors de la suppression");
//     }
//   };

//   // Déclenche le téléchargement d'un blob, en récupérant le nom de fichier
//   // depuis l'en-tête Content-Disposition si le serveur le fournit
//   const triggerBlobDownload = (blob, res, fallbackName) => {
//     const disposition = res.headers.get("Content-Disposition") || "";
//     const match = disposition.match(/filename="?([^"]+)"?/);
//     const filename = match ? match[1] : fallbackName;

//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//     window.URL.revokeObjectURL(url);
//   };

//   const downloadMouvementAttachments = async (mouvementId) => {
//     setDownloadingId(mouvementId);
//     try {
//       const response = await exportMouvementPj(mouvementId);

//       const disposition = response.headers["content-disposition"];
//       let filename = `mouvement-${mouvementId}-pj.zip`;
//       if (disposition) {
//         const match = disposition.match(/filename="?([^"]+)"?/);
//         if (match && match[1]) filename = match[1];
//       }

//       const blob = new Blob([response.data], { type: "application/zip" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (err) {
//       // Le backend renvoie du JSON (status 404/500) même si on attend un blob ;
//       // axios ne le parse pas automatiquement en mode "blob", d'où ce petit
//       // décodage manuel pour afficher un message d'erreur lisible.
//       let description = "Erreur lors du téléchargement des pièces jointes";
//       if (err.response?.data instanceof Blob) {
//         try {
//           const text = await err.response.data.text();
//           const parsed = JSON.parse(text);
//           description = parsed.description || description;
//         } catch (_) {
//           // le corps n'était pas du JSON exploitable, on garde le message par défaut
//         }
//       }
//       message.error(description);
//     } finally {
//       setDownloadingId(null);
//     }
//   };

//   const exportMouvements = async (format = "xlsx") => {
//     setExporting(true);
//     try {
//       const params = {
//         caisse_id: caisseId,
//         du: filters.from,
//         au: filters.to,
//         format: format,
//       };

//       if (filters.departement_id) {
//         params.departement_id = filters.departement_id;
//       }
//       if (filters.mode_paiement_id) {
//         params.mode_paiement_id = filters.mode_paiement_id;
//       }
//       if (filters.type) {
//         params.type = filters.type;
//       }
//       if (filters.q) {
//         params.q = filters.q;
//       }

//       console.log('-----------------------------')
//       const response = await exportMouvementsApi(params);

//       // Récupère le nom de fichier envoyé par le back (Content-Disposition)
//       const disposition = response.headers["content-disposition"];
//       let filename = `export_depenses_${filters.from}_au_${filters.to}.zip`;
//       if (disposition) {
//         const match = disposition.match(/filename="?([^"]+)"?/);
//         if (match && match[1]) filename = match[1];
//       }

//       // Déclenche le téléchargement dans le navigateur
//       const blob = new Blob([response.data], { type: "application/zip" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);

//       message.success("Export généré avec succès");
//     } catch (err) {
//       message.error(err.message || "Erreur lors de l'export des mouvements");
//     } finally {
//       setExporting(false);
//     }
//   };

//   const totalRecette = rows
//     .filter((m) => m.type === "recette")
//     .reduce((s, m) => s + (Number(m.montant) || 0), 0);

//   const totalDepense = rows
//     .filter((m) => m.type === "depense")
//     .reduce((s, m) => s + (Number(m.montant) || 0), 0);

//   // const columns = [
//   //   { title: "Id", dataIndex: "id" },
//   //   { title: "Date", dataIndex: "date", render: (d) => fmtDate(d), width: 110 },
//   //   {
//   //     title: "Référence",
//   //     dataIndex: "reference",
//   //     width: 160,
//   //     render: (v, r) => (
//   //       <div style={{ lineHeight: 1.3 }}>
//   //         <div style={{ fontWeight: 500 }}>{v || "—"}</div>
//   //         {r.ref_piece && (
//   //           <div style={{ fontSize: 12, color: "#8c8c8c" }}>{r.ref_piece}</div>
//   //         )}
//   //       </div>
//   //     ),
//   //   },
//   //   { title: "Libellé", dataIndex: "libelle", ellipsis: true, width: 220 },
//   //   {
//   //     title: "Département",
//   //     dataIndex: "departement",
//   //     render: (v) => <Tag>{v}</Tag>,
//   //     width: 160,
//   //   },
//   //   {
//   //     title: "Catégorie",
//   //     dataIndex: "categorie",
//   //     render: (v) => (v ? <Tag color="blue">{v}</Tag> : "—"),
//   //     width: 150,
//   //   },
//   //   { title: "Mode", dataIndex: "mode", width: 130 },
//   //   {
//   //     title: "Recette",
//   //     dataIndex: "montant",
//   //     align: "right",
//   //     width: 140,
//   //     render: (v, r) =>
//   //       r.type === "recette" ? (
//   //         <span style={{ color: "#16a34a", fontWeight: 500 }}>{fmt(v)}</span>
//   //       ) : (
//   //         "—"
//   //       ),
//   //   },
//   //   {
//   //     title: "Dépense",
//   //     dataIndex: "montant",
//   //     align: "right",
//   //     width: 140,
//   //     render: (v, r) =>
//   //       r.type === "depense" ? (
//   //         <span style={{ color: "#dc2626", fontWeight: 500 }}>{fmt(v)}</span>
//   //       ) : (
//   //         "—"
//   //       ),
//   //   },
//   //   {
//   //     title: "Solde",
//   //     dataIndex: "solde",
//   //     align: "right",
//   //     width: 150,
//   //     render: (v) => <b>{fmt(v)}</b>,
//   //   },
//   //   {
//   //     title: "",
//   //     key: "actions",
//   //     // width: 170,
//   //     align: "right",
//   //     fixed: "right",
//   //     render: (_, r) => (
//   //       <Space>
//   //         <Button
//   //           size="small"
//   //           type="text"
//   //           icon={<PaperClipOutlined />}
//   //           title="Rattacher une pièce jointe"
//   //           onClick={() => setAttachMvt(r)}
//   //         />
//   //         <Button
//   //           size="medium"
//   //           type="text"
//   //           icon={<DownloadOutlined />}
//   //           title="Télécharger les pièces jointes"
//   //           loading={downloadingId === r.id}
//   //           onClick={() => downloadMouvementAttachments(r.id)}
//   //         />
//   //       </Space>
//   //     ),
//   //   },
//   // ];

//     const columns = [
//     {
//       title: "Id",
//       dataIndex: "id",
//       width: 70,
//       render: (v) => <Typography.Text type="secondary">#{v}</Typography.Text>,
//     },
//     {
//       title: "Date",
//       dataIndex: "date",
//       width: 125,
//       render: (d) => (
//         <Space size={6}>
//           <CalendarOutlined style={{ color: "#8c8c8c" }} />
//           {fmtDate(d)}
//         </Space>
//       ),
//     },
//     {
//       title: "Libellé",
//       dataIndex: "libelle",
//       ellipsis: { showTitle: false },
//       width: 240,
//       render: (v) => (
//         <Tooltip placement="topLeft" title={v}>
//           <span style={{ fontWeight: 500 }}>{v}</span>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Référence",
//       dataIndex: "reference",
//       width: 170,
//       render: (v, r) => (
//         <div style={{ lineHeight: 1.35 }}>
//           <div style={{ fontWeight: 600 }}>{v || r.ref_piece || "—"}</div>
//           {v && r.ref_piece && (
//             <Tag
//               bordered={false}
//               style={{ marginTop: 2, fontSize: 11, color: "#8c8c8c", background: "#f5f5f5" }}
//             >
//               {r.ref_piece}
//             </Tag>
//           )}
//         </div>
//       ),
//     },
//     {
//       title: "Département",
//       dataIndex: "departement",
//       width: 160,
//       render: (v) =>
//         v ? (
//           <Tag color={colorFromText(v)} style={{ borderRadius: 12, padding: "0 10px" }}>
//             {v}
//           </Tag>
//         ) : (
//           "—"
//         ),
//     },
//     {
//       title: "Catégorie",
//       dataIndex: "categorie",
//       width: 150,
//       render: (v) =>
//         v ? (
//           <Tag color="blue" bordered={false} style={{ borderRadius: 12 }}>
//             {v}
//           </Tag>
//         ) : (
//           <Typography.Text type="secondary">—</Typography.Text>
//         ),
//     },
//     {
//       title: "Mode",
//       dataIndex: "mode",
//       width: 140,
//       render: (v) => {
//         if (!v) return "—";
//         const { color, icon } = modeMeta(v);
//         return (
//           <Tag color={color} icon={icon}>
//             {v}
//           </Tag>
//         );
//       },
//     },
//     {
//       title: "Recette",
//       dataIndex: "montant",
//       align: "right",
//       width: 150,
//       render: (v, r) =>
//         r.type === "recette" ? (
//           <Tag
//             color="success"
//             icon={<ArrowDownOutlined />}
//             style={{ fontWeight: 600, fontSize: 13, marginRight: 0 }}
//           >
//             {fmt(v)}
//           </Tag>
//         ) : (
//           <Typography.Text type="secondary">—</Typography.Text>
//         ),
//     },
//     {
//       title: "Dépense",
//       dataIndex: "montant",
//       align: "right",
//       width: 150,
//       render: (v, r) =>
//         r.type === "depense" ? (
//           <Tag
//             color="error"
//             icon={<ArrowUpOutlined />}
//             style={{ fontWeight: 600, fontSize: 13, marginRight: 0 }}
//           >
//             {fmt(v)}
//           </Tag>
//         ) : (
//           <Typography.Text type="secondary">—</Typography.Text>
//         ),
//     },
//     {
//       title: "Solde",
//       dataIndex: "solde",
//       align: "right",
//       width: 150,
//       render: (v) => (
//         <b style={{ color: Number(v) < 0 ? "#dc2626" : "#0f172a", fontSize: 14 }}>
//           {fmt(v)}
//         </b>
//       ),
//     },
//     {
//       title: "",
//       key: "actions",
//       align: "right",
//       fixed: "right",
//       width: 90,
//       render: (_, r) => (
//         <Space size={0}>
//           <Tooltip title="Rattacher une pièce jointe">
//             <Button
//               size="small"
//               type="text"
//               icon={<PaperClipOutlined />}
//               onClick={() => setAttachMvt(r)}
//             />
//           </Tooltip>
//           <Tooltip title="Télécharger les pièces jointes">
//             <Button
//               size="small"
//               type="text"
//               icon={<DownloadOutlined />}
//               loading={downloadingId === r.id}
//               onClick={() => downloadMouvementAttachments(r.id)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div className="d-flex flex-column gap-3 pt-3">
//       <Card
//         size="small"
//         title={
//           <span>
//             <i className="bi bi-funnel me-2"></i>Filtrer les mouvements
//           </span>
//         }
//       >
//         <Row gutter={[12, 12]}>
//           <Col xs={12} sm={8} md={4}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Du
//             </div>

//             <DatePicker
//               style={{ width: "100%", height: 32 }}
//               value={moment(filters.from)}
//               format="YYYY-MM-DD"
//               onChange={(d) =>
//                 setFilter({
//                   from: d ? d.format("YYYY-MM-DD") : null,
//                 })
//               }
//             />
//           </Col>
//           <Col xs={12} sm={8} md={4}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Au
//             </div>
//             <DatePicker
//               style={{ width: "100%", height: 32 }}
//               value={moment(filters.to)}
//               onChange={(d) =>
//                 setFilter({ to: d ? d.format("YYYY-MM-DD") : filters.to })
//               }
//             />
//           </Col>
//           <Col xs={24} sm={8} md={5}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Département
//             </div>
//             <Select
//               allowClear
//               style={{ width: "100%" }}
//               placeholder="Tous"
//               value={filters.departement_id}
//               onChange={(v) => setFilter({ departement_id: v ?? null })}
//               options={departements.map((d) => ({ value: d.id, label: d.nom }))}
//             />
//           </Col>
//           <Col xs={12} sm={8} md={4}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Mode
//             </div>
//             <Select
//               allowClear
//               style={{ width: "100%" }}
//               placeholder="Tous"
//               value={filters.mode_paiement_id}
//               onChange={(v) => setFilter({ mode_paiement_id: v ?? null })}
//               options={modesPaiement.map((m) => ({
//                 value: m.id,
//                 label: m.nom,
//               }))}
//             />
//           </Col>
//           <Col xs={12} sm={8} md={3}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Type
//             </div>
//             <Select
//               allowClear
//               style={{ width: "100%" }}
//               placeholder="Tous"
//               value={filters.type}
//               onChange={(v) => setFilter({ type: v ?? null })}
//               options={TYPES_MOUVEMENT}
//             />
//           </Col>
//           <Col xs={24} sm={16} md={4}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Recherche
//             </div>
//             <Input
//               className="movement-search"
//               placeholder="Libellé..."
//               allowClear
//               prefix={<i className="bi bi-search text-secondary"></i>}
//               value={filters.q}
//               onChange={(e) => setFilter({ q: e.target.value })}
//             />
//           </Col>
//         </Row>
//       </Card>

//       <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
//         <div className="d-flex gap-3 flex-wrap">
//           <span className="text-secondary">{total} mouvement(s)</span>
//           <span style={{ color: "#16a34a", fontWeight: 500 }}>
//             + {fmt(totalRecette)}
//           </span>
//           <span style={{ color: "#dc2626", fontWeight: 500 }}>
//             − {fmt(totalDepense)}
//           </span>
//         </div>
//         <Space>
//           {/* <Button
//             icon={<i className="bi bi-paperclip me-1"></i>}
//             loading={downloadingMonth}
//             onClick={downloadMonthAttachments}
//           >
//             Télécharger les PJ du mois
//           </Button> */}
//           <Button
//             icon={<i className="bi bi-download me-1"></i>}
//             loading={exporting}
//             onClick={() => exportMouvements("xlsx")}
//           >
//             Exporter (Excel / PDF)
//           </Button>
//         </Space>
//       </div>

//       <Card size="small">
//         <Table
//           dataSource={rows}
//           columns={columns}
//           rowKey="id"
//           size="small"
//           scroll={{ x: "max-content" }}
//           loading={loading}
//           pagination={{
//             current: filters.page,
//             pageSize: 10,
//             total,
//             showSizeChanger: false,
//             onChange: (page) => setFilter({ page }),
//           }}
//         />
//       </Card>

//       {attachMvt && (
//         <AttachmentModal
//           mouvement={attachMvt}
//           onClose={() => setAttachMvt(null)}
//           onSaved={() => {
//             setAttachMvt(null);
//             load();
//           }}
//         />
//       )}
//     </div>
//   );
// }

// function AttachmentModal({ mouvement, onClose, onSaved }) {
//   const [fileList, setFileList] = useState([]); // éléments { uid, name, url (objectURL), file }
//   const [saving, setSaving] = useState(false);

//   // Nettoie les URL objets créées pour la prévisualisation, pour éviter les fuites mémoire
//   useEffect(() => {
//     return () => {
//       fileList.forEach((f) => f.url && URL.revokeObjectURL(f.url));
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const addFiles = (newFiles) => {
//     const mapped = newFiles.map((file) => ({
//       uid: `${file.name}-${file.lastModified}-${Math.random().toString(36).slice(2)}`,
//       name: file.name,
//       url: URL.createObjectURL(file),
//       file,
//     }));
//     setFileList((prev) => [...prev, ...mapped]);
//   };

//   // beforeUpload renvoyant false empêche antd d'envoyer le fichier tout seul :
//   // on garde la main sur l'upload final (voir submit()).
//   const beforeUpload = (file, allFiles) => {
//     addFiles(allFiles);
//     return false;
//   };

//   const removeFile = (uid) => {
//     setFileList((prev) => {
//       const target = prev.find((f) => f.uid === uid);
//       if (target?.url) URL.revokeObjectURL(target.url);
//       return prev.filter((f) => f.uid !== uid);
//     });
//   };

//   const submit = async () => {
//     if (!fileList.length) {
//       message.warning("Ajoute au moins une image avant d'enregistrer");
//       return;
//     }
//     setSaving(true);
//     try {
//       const formData = new FormData();
//       fileList.forEach((f) => formData.append("pj", f.file));

//       // NOTE : adapte cet appel si la signature réelle de addpj diffère
//       // (ex : addpj(formData) avec mouvement_id déjà inclus dedans).
//       await addpj(mouvement.id, formData);

//       message.success("Pièce(s) jointe(s) enregistrée(s)");
//       onSaved();
//     } catch (e) {
//       message.error(
//         e.response?.data?.description ||
//         e.response?.data?.message ||
//         e.message ||
//         "Erreur lors de l'envoi des pièces jointes",
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Modal
//       open={true}
//       onCancel={onClose}
//       title={
//         <span>
//           <PaperClipOutlined className="me-2" />
//           Pièces jointes — {mouvement.libelle}
//         </span>
//       }
//       width="min(520px, 92vw)"
//       footer={[
//         <Button key="cancel" onClick={onClose}>
//           Annuler
//         </Button>,
//         <Button
//           key="save"
//           type="primary"
//           loading={saving}
//           disabled={!fileList.length}
//           icon={<i className="bi bi-check-lg me-1"></i>}
//           onClick={submit}
//         >
//           Enregistrer
//         </Button>,
//       ]}
//     >
//       <div className="pt-2">
//         <div className="attach-actions">
//           {/* capture="environment" = ouvre directement la caméra arrière sur mobile */}
//           <Upload
//             accept="image/*"
//             capture="environment"
//             multiple={false}
//             showUploadList={false}
//             beforeUpload={(file) => beforeUpload(file, [file])}
//           >
//             <Button icon={<CameraOutlined />} block>
//               Prendre une photo
//             </Button>
//           </Upload>

//           <Upload
//             accept="image/*"
//             multiple
//             showUploadList={false}
//             beforeUpload={(file, allFiles) => beforeUpload(file, allFiles)}
//           >
//             <Button icon={<UploadOutlined />} block>
//               Choisir des fichiers
//             </Button>
//           </Upload>
//         </div>

//         {fileList.length === 0 ? (
//           <Empty
//             className="pt-4"
//             image={
//               <FileImageOutlined style={{ fontSize: 32, color: "#c1c7d0" }} />
//             }
//             description="Aucune pièce jointe sélectionnée"
//           />
//         ) : (
//           <div className="attach-preview-grid">
//             {fileList.map((f) => (
//               <div className="attach-preview-item" key={f.uid}>
//                 <img src={f.url} alt={f.name} />
//                 <button
//                   type="button"
//                   className="attach-preview-remove"
//                   onClick={() => removeFile(f.uid)}
//                   title="Retirer"
//                 >
//                   <DeleteOutlined />
//                 </button>
//                 <div className="attach-preview-name">{f.name}</div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </Modal>
//   );
// }

// // ---------------------------------------------------------------------
// // Départements
// // ---------------------------------------------------------------------

// function DepartementsTab({
//   caisseId,
//   departements,
//   setDepartements,
//   agence_id,
//   onDeptChanged,
// }) {
//   const [form, setForm] = useState({
//     nom: "",
//     code: "",
//     responsable: "",
//     couleur: "#1677ff",
//   });
//   const [saving, setSaving] = useState(false);
//   const [spendByDept, setSpendByDept] = useState({});

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await getDashboard(caisseId);
//         const map = {};
//         res.data.depensesParDepartement.forEach((d) => {
//           map[d.nom] = d.total;
//         });
//         setSpendByDept(map);
//       } catch (e) {
//         // Non bloquant pour cet onglet
//       }
//     })();
//   }, [caisseId, departements]);

//   const addDept = async () => {
//     if (!form.nom.trim()) {
//       console.log("erreur");
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         ...form,
//         agence_id: agence_id,
//       };
//       const res = await createDepartement(payload);
//       setDepartements((prev) => [...prev, res.data]);

//       setForm({
//         nom: "",
//         code: "",
//         responsable: "",
//         couleur: "#1677ff",
//       });

//       message.success("Département ajouté");
//       onDeptChanged?.();
//     } catch (e) {
//       message.error(e.message || "Erreur lors de la création du département");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const removeDept = async (id) => {
//     try {
//       await deleteDepartement(id);
//       setDepartements((prev) => prev.filter((x) => x.id !== id));
//       onDeptChanged?.();
//     } catch (e) {
//       message.error(
//         e.message || "Erreur lors de la suppression du département",
//       );
//     }
//   };

//   return (
//     <Row gutter={[20, 16]} className="pt-3">
//       <Col xs={24} lg={16} className="d-flex flex-column gap-2">
//         {departements.map((d) => (
//           <Card key={d.id} size="small">
//             <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
//               <div
//                 className="d-flex align-items-center gap-3"
//                 style={{ minWidth: 0 }}
//               >
//                 <div className="dept-swatch" style={{ background: d.couleur }}>
//                   {d.code}
//                 </div>
//                 <div style={{ minWidth: 0 }}>
//                   <div style={{ fontSize: 14, fontWeight: 600 }}>{d.nom}</div>
//                   <div className="text-secondary" style={{ fontSize: 12 }}>
//                     Responsable : {d.responsable || "—"}
//                   </div>
//                 </div>
//               </div>
//               <div className="d-flex align-items-center gap-4">
//                 <div className="text-end">
//                   <div className="text-secondary" style={{ fontSize: 12 }}>
//                     Dépenses (mois)
//                   </div>
//                   <div
//                     style={{
//                       fontSize: 14,
//                       fontWeight: 600,
//                       color: "#dc2626",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {fmt(spendByDept[d.nom] || 0)}
//                   </div>
//                 </div>
//                 <Space>
//                   <Button
//                     size="small"
//                     type="text"
//                     icon={<i className="bi bi-pencil"></i>}
//                   />
//                   <Button
//                     size="small"
//                     type="text"
//                     danger
//                     icon={<i className="bi bi-trash"></i>}
//                     onClick={() => removeDept(d.id)}
//                   />
//                 </Space>
//               </div>
//             </div>
//             <CategoriesDepartement departementId={d.id} />
//           </Card>
//         ))}
//       </Col>

//       <Col xs={24} lg={8}>
//         <Card size="small" title="Ajouter un département">
//           <div className="d-flex flex-column gap-2">
//             <div>
//               <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//                 Nom
//               </div>
//               <Input
//                 value={form.nom}
//                 placeholder="Ex : Entretien"
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, nom: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//                 Code (3 lettres)
//               </div>
//               <Input
//                 value={form.code}
//                 placeholder="ETR"
//                 maxLength={4}
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, code: e.target.value.toUpperCase() }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//                 Responsable
//               </div>
//               <Input
//                 value={form.responsable}
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, responsable: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//                 Couleur
//               </div>
//               <div className="d-flex align-items-center gap-2">
//                 <input
//                   type="color"
//                   value={form.couleur}
//                   onChange={(e) =>
//                     setForm((f) => ({ ...f, couleur: e.target.value }))
//                   }
//                   style={{
//                     width: 40,
//                     height: 32,
//                     border: "1px solid #d9d9d9",
//                     borderRadius: 6,
//                     padding: 2,
//                     cursor: "pointer",
//                   }}
//                 />
//                 <Input
//                   value={form.couleur}
//                   onChange={(e) =>
//                     setForm((f) => ({ ...f, couleur: e.target.value }))
//                   }
//                   style={{ width: 110 }}
//                 />
//               </div>
//             </div>
//             <Button
//               type="primary"
//               block
//               loading={saving}
//               icon={<i className="bi bi-plus-lg me-1"></i>}
//               onClick={addDept}
//             >
//               Ajouter le département
//             </Button>
//           </div>
//         </Card>
//       </Col>
//     </Row>
//   );
// }

// // ---------------------------------------------------------------------
// // Modal ajout mouvement
// // ---------------------------------------------------------------------

// function CategoriesDepartement({ departementId }) {
//   const [categories, setCategories] = useState([]);
//   const [nom, setNom] = useState("");
//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await getCategories(departementId);
//         setCategories(res.data || []);
//       } catch (e) {
//         message.error(e.message || "Erreur lors du chargement des catégories");
//       }
//     })();
//   }, [departementId]);

//   const add = async () => {
//     if (!nom.trim()) return;
//     setSaving(true);
//     try {
//       const res = await createCategorie(departementId, { nom: nom.trim() });
//       setCategories((prev) => [...prev, res.data]);
//       setNom("");
//     } catch (e) {
//       message.error(e.message || "Erreur lors de la création de la catégorie");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const remove = async (id) => {
//     try {
//       await deleteCategorie(id);
//       setCategories((prev) => prev.filter((c) => c.id !== id));
//     } catch (e) {
//       message.error(e.message || "Erreur lors de la suppression");
//     }
//   };

//   return (
//     <div className="mt-2 pt-2" style={{ borderTop: "1px dashed #e8ecf3" }}>
//       <div className="d-flex align-items-center flex-wrap gap-2">
//         <span className="text-secondary" style={{ fontSize: 12 }}>
//           Catégories :
//         </span>
//         {categories.length === 0 && (
//           <span className="text-secondary" style={{ fontSize: 12 }}>
//             aucune
//           </span>
//         )}
//         {categories.map((c) => (
//           <Tag
//             key={c.id}
//             closable
//             onClose={(e) => {
//               e.preventDefault();
//               remove(c.id);
//             }}
//           >
//             {c.nom}
//           </Tag>
//         ))}
//         <Input
//           size="small"
//           style={{ width: 170 }}
//           value={nom}
//           placeholder="Nouvelle catégorie"
//           onChange={(e) => setNom(e.target.value)}
//           onPressEnter={add}
//         />
//         <Button
//           size="small"
//           loading={saving}
//           onClick={add}
//           icon={<i className="bi bi-plus-lg"></i>}
//         />
//       </div>
//     </div>
//   );
// }

// function AddMovementModal({
//   caisseId,
//   departements,
//   modesPaiement,
//   onClose,
//   onSaved,
// }) {
//   const [saving, setSaving] = useState(false);
//   const [categories, setCategories] = useState([]);

//   const [form, setForm] = useState({
//     date: fmtDateInput(new Date()),
//     libelle: "",
//     departement_id: departements[0] ? departements[0].id : null,
//     mode_paiement_id: modesPaiement[0] ? modesPaiement[0].id : null,
//     montant: null,
//     type: "depense",
//     pj: [],
//   });

//   useEffect(() => {
//     if (!form.departement_id) {
//       setCategories([]);
//       return;
//     }
//     (async () => {
//       try {
//         const res = await getCategories(form.departement_id);
//         setCategories(res.data || []);
//       } catch (e) {
//         setCategories([]);
//       }
//     })();
//   }, [form.departement_id]);

//   const submit = async () => {
//     if (
//       !form.libelle.trim() ||
//       !form.montant ||
//       !form.departement_id ||
//       !form.mode_paiement_id
//     ) {
//       message.warning("Merci de remplir tous les champs");
//       return;
//     }

//     setSaving(true);

//     try {
//       const formData = new FormData();
//       formData.append("date", form.date);
//       formData.append("libelle", form.libelle);
//       formData.append("departement_id", form.departement_id);
//       if (form.categorie_id) formData.append("categorie_id", form.categorie_id);
//       formData.append("mode_paiement_id", form.mode_paiement_id);
//       formData.append("montant", Number(form.montant));
//       formData.append("type", form.type);
//       formData.append("caisse_id", caisseId);
//       // Ajouter les fichiers
//       (form.pj || []).forEach((file) => {
//         if (file.originFileObj) {
//           formData.append("pj", file.originFileObj);
//         }
//       });
//       await createMouvement(formData);
//       message.success("Mouvement enregistré");
//       onSaved();
//     } catch (e) {
//       message.error(
//         e.response?.data?.message ||
//         e.message ||
//         "Erreur lors de l'enregistrement du mouvement",
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Modal
//       open={true}
//       onCancel={onClose}
//       title="Nouveau mouvement"
//       width="min(520px, 92vw)"
//       footer={[
//         <Button key="cancel" onClick={onClose}>
//           Annuler
//         </Button>,
//         <Button
//           key="save"
//           type="primary"
//           loading={saving}
//           icon={<i className="bi bi-check-lg me-1"></i>}
//           onClick={submit}
//         >
//           Enregistrer
//         </Button>,
//       ]}
//     >
//       <div className="d-flex flex-column gap-3 pt-2">
//         <Row gutter={[12, 12]}>
//           <Col xs={24} sm={12}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Type
//             </div>
//             <Select
//               style={{ width: "100%" }}
//               value={form.type}
//               onChange={(v) => setForm((f) => ({ ...f, type: v }))}
//               options={TYPES_MOUVEMENT}
//             />
//           </Col>
//           <Col xs={24} sm={12}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Date
//             </div>
//             <DatePicker
//               style={{ width: "100%", height: 32 }}
//               value={moment(form.date)}
//               onChange={(d) =>
//                 setForm((f) => ({
//                   ...f,
//                   date: d ? d.format("YYYY-MM-DD") : f.date,
//                 }))
//               }
//             />
//           </Col>
//         </Row>

//         <div>
//           <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//             Libellé
//           </div>
//           <Input
//             value={form.libelle}
//             placeholder="Ex : Fret camion 3947 AJ"
//             onChange={(e) =>
//               setForm((f) => ({ ...f, libelle: e.target.value }))
//             }
//           />
//         </div>

//         <Row gutter={[12, 12]}>
//           <Col xs={24} sm={12}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Département
//             </div>
//             <Select
//               style={{ width: "100%" }}
//               value={form.departement_id}
//               // onChange={(v) => setForm((f) => ({ ...f, departement_id: v }))}
//               onChange={(v) =>
//                 setForm((f) => ({ ...f, departement_id: v, categorie_id: null }))
//               }
//               options={departements.map((d) => ({ value: d.id, label: d.nom }))}
//             />
//           </Col>
//           <Col xs={24} sm={12}>
//             <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//               Mode de paiement
//             </div>
//             <Select
//               style={{ width: "100%" }}
//               value={form.mode_paiement_id}
//               onChange={(v) => setForm((f) => ({ ...f, mode_paiement_id: v }))}
//               options={modesPaiement.map((m) => ({
//                 value: m.id,
//                 label: m.nom,
//               }))}
//             />
//           </Col>
//         </Row>

//         <div>
//           <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//             Catégorie
//           </div>
//           <Select
//             style={{ width: "100%" }}
//             allowClear
//             disabled={categories.length === 0}
//             placeholder={
//               categories.length === 0
//                 ? "Aucune catégorie pour ce département"
//                 : "Choisir une catégorie (optionnel)"
//             }
//             value={form.categorie_id}
//             onChange={(v) => setForm((f) => ({ ...f, categorie_id: v ?? null }))}
//             options={categories.map((c) => ({ value: c.id, label: c.nom }))}
//           />
//         </div>


//         <div>
//           <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
//             Montant (Ar)
//           </div>
//           <InputNumber
//             style={{ width: "100%" }}
//             min={0}
//             value={form.montant}
//             placeholder="0"
//             formatter={(v) =>
//               v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ") : ""
//             }
//             onChange={(v) => setForm((f) => ({ ...f, montant: v }))}
//           />
//         </div>
//         <Row gutter={16}>
//           <Col span={24}>
//             <Row align="middle" gutter={8}>
//               <Col span={5} style={{ textAlign: "center" }}>
//                 Pièces jointes
//               </Col>

//               <Col span={19}>
//                 <Upload
//                   multiple
//                   beforeUpload={() => false}
//                   fileList={form.pj || []}
//                   onChange={({ fileList }) => {
//                     setForm((f) => ({
//                       ...f,
//                       pj: fileList,
//                     }));
//                   }}
//                 >
//                   <Button icon={<UploadOutlined />}>
//                     Ajouter des fichiers
//                   </Button>
//                 </Upload>
//               </Col>
//             </Row>
//           </Col>
//         </Row>
//       </div>
//     </Modal>
//   );
// }

import React, { useState, useEffect, useMemo, useCallback } from "react";
import dayjs from "dayjs";
import moment from "moment";
import {
  Layout,
  Button,
  Select,
  Tabs,
  Card,
  Row,
  Col,
  Table,
  Modal,
  Input,
  InputNumber,
  DatePicker,
  Tag,
  Progress,
  Empty,
  Space,
  message,
  Upload,
  Image,
  Tooltip,
  Typography,
} from "antd";
import {
  getCaisses,
  getDepartements,
  getModesPaiement,
  getDashboard,
  getMouvements,
  createMouvement,
  deleteMouvement,
  createDepartement,
  deleteDepartement,
  addpj,
  exportMouvements as exportMouvementsApi,
  exportMouvementPj,
  getCategories,
  createCategorie,
  deleteCategorie,
} from "../../api/caisseapi";
import {
  UploadOutlined,
  PaperClipOutlined,
  CameraOutlined,
  DeleteOutlined,
  FileImageOutlined,
  DownloadOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  CalendarOutlined,
  BankOutlined,
  WalletOutlined,
  SwapOutlined,
  CreditCardOutlined,
  MobileOutlined,
  FileTextOutlined,
  SearchOutlined,
  FilterFilled,
} from "@ant-design/icons";

const { Header, Content } = Layout;

const TYPES_MOUVEMENT = [
  { value: "depense", label: "Dépense" },
  { value: "recette", label: "Recette" },
];

const fmt = (n) =>
  new Intl.NumberFormat("fr-MG", { maximumFractionDigits: 0 }).format(n || 0) +
  " Ar";
const toDate = (d) => (d instanceof Date ? d : new Date(d));
const fmtDate = (d) =>
  toDate(d).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
const fmtDateInput = (d) => toDate(d).toISOString().slice(0, 10);
const monthLabel = (d) =>
  d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

function SoldeAreaChart({ data }) {
  if (!data.length) return <Empty description="Pas de données" />;
  const width = 600,
    height = 200,
    pad = 10;
  const values = data.map((d) => d.solde);
  const min = Math.min(...values),
    max = Math.max(...values);
  const span = max - min || 1;
  const pts = data.map((d, i) => {
    const x = pad + (i / Math.max(data.length - 1, 1)) * (width - 2 * pad);
    const y = height - pad - ((d.solde - min) / span) * (height - 2 * pad);
    return [x, y];
  });
  const line = pts
    .map((p, i) => (i === 0 ? "M" : "L") + p[0] + "," + p[1])
    .join(" ");
  const area =
    line +
    ` L${pts[pts.length - 1][0]},${height - pad} L${pts[0][0]},${height - pad} Z`;
  const last = pts[pts.length - 1];
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      style={{ width: "100%", height: "auto", display: "block" }}
    >
      <defs>
        <linearGradient id="soldeGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1677ff" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#1677ff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill="url(#soldeGrad)" stroke="none" />
      <path d={line} fill="none" stroke="#1677ff" strokeWidth="2" />
      <circle cx={last[0]} cy={last[1]} r="4" fill="#1677ff" />
    </svg>
  );
}

const GLOBAL_STYLES = `
  /* Le conteneur hôte (index.html) limite parfois déjà html/body en
     hauteur avec overflow:hidden pour faire des layouts "app-like".
     On neutralise ça ici et on gère nous-mêmes un seul niveau de scroll,
     pour être sûr que tout le contenu (tableaux, pagination, formulaires)
     reste atteignable quelle que soit la hauteur de l'écran. */
  html, body, #root { height: 100%; }

  .caisse-app {
    background:#f5f7fb;
    font-family: -apple-system, "Segoe UI", Inter, sans-serif;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /* Seule cette zone défile : le header reste visible, tout le reste
     (KPI, graphiques, tableaux + leur pagination, formulaires) devient
     accessible en scrollant, même sur un écran bas (12 pouces ~768px). */
  .app-scroll {
    flex: 1 1 auto;
    min-height: 0; /* indispensable dans un flex column pour autoriser le scroll interne */
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .kpi-icon { width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0; }
  .app-header { background:#fff;border-bottom:1px solid #e8ecf3; flex-shrink:0; }
  .brand-badge { width:36px;height:36px;border-radius:8px;background:#1677ff;color:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
  .dept-swatch { width:36px;height:36px;border-radius:8px;color:#fff;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:600;flex-shrink:0; }
  .movement-search .ant-input-affix-wrapper { border-radius:8px; }
  .ant-tabs-tab { font-weight:500; }
  .app-shell { max-width:1400px; margin:0 auto; width:100%; box-sizing:border-box; }

  /* Le contenu des tableaux ne doit jamais être coupé silencieusement :
     on force toujours un scroll horizontal interne au composant Table
     plutôt que de laisser les colonnes déborder de la carte. */
  .ant-table-wrapper { width:100%; overflow-x:auto; }
  .ant-table { min-width: 100%; }

  /* Liseré de couleur à gauche des lignes du tableau des mouvements */
  .row-recette td:first-child { border-left: 3px solid #16a34a; }
  .row-depense td:first-child { border-left: 3px solid #dc2626; }

  /* Zone de rattachement de pièces jointes : deux gros boutons tactiles
     (photo / fichiers) qui restent confortables au doigt sur mobile. */
  .attach-actions { display:flex; gap:10px; flex-wrap:wrap; }
  .attach-actions .ant-btn { flex:1 1 160px; height:44px; }
  .attach-preview-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(84px,1fr)); gap:10px; margin-top:14px; }
  .attach-preview-item { position:relative; border:1px solid #e8ecf3; border-radius:8px; overflow:hidden; aspect-ratio:1/1; background:#f5f7fb; }
  .attach-preview-item img { width:100%; height:100%; object-fit:cover; display:block; }
  .attach-preview-remove { position:absolute; top:4px; right:4px; background:rgba(0,0,0,0.55); border:none; color:#fff; width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; cursor:pointer; font-size:12px; line-height:1; }
  .attach-preview-name { font-size:10px; color:#fff; background:rgba(0,0,0,0.55); position:absolute; bottom:0; left:0; right:0; padding:2px 4px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }

  /* Écrans <= 1366px (13 pouces et moins, dont la plupart des 12 pouces) */
  @media (max-width: 1366px) {
    .app-shell { padding-left:16px !important; padding-right:16px !important; }
    .app-header { padding-left:16px; padding-right:16px; }
  }

  /* Écrans <= 991px : le header passe en colonne pour ne jamais tronquer
     le sélecteur de caisse ou le bouton "Nouveau mouvement". */
  @media (max-width: 991px) {
    .app-header {
      height:auto !important;
      flex-direction:column;
      align-items:stretch !important;
      gap:12px;
      padding-top:12px;
      padding-bottom:12px;
    }
    .app-header .header-actions { width:100%; }
    .app-header .header-actions .ant-select { width:100% !important; }
    .app-header .header-actions .ant-btn { width:100%; }
  }

  /* Écrans <= 576px : ajustements fins pour mobile / petites tablettes */
  @media (max-width: 576px) {
    .kpi-icon { width:34px;height:34px;font-size:16px; }
    .app-shell { padding-left:10px !important; padding-right:10px !important; }
  }
`;

const PALETTE = [
  "geekblue",
  "purple",
  "cyan",
  "magenta",
  "volcano",
  "gold",
  "lime",
];
const colorFromText = (txt = "") => {
  let h = 0;
  for (const c of String(txt)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
};

const MODE_META = {
  espèces: { color: "green", icon: <WalletOutlined /> },
  especes: { color: "green", icon: <WalletOutlined /> },
  chèque: { color: "orange", icon: <FileTextOutlined /> },
  cheque: { color: "orange", icon: <FileTextOutlined /> },
  virement: { color: "blue", icon: <BankOutlined /> },
  carte: { color: "purple", icon: <CreditCardOutlined /> },
  mobile: { color: "cyan", icon: <MobileOutlined /> },
};
const modeMeta = (m) =>
  MODE_META[String(m || "").toLowerCase()] || {
    color: "default",
    icon: <SwapOutlined />,
  };

// ---------------------------------------------------------------------
// Helpers de filtres de colonnes (filtrage côté client sur les lignes
// de la page affichée)
// ---------------------------------------------------------------------

const norm = (v) => String(v ?? "").toLowerCase();

const filterIcon = (filtered) => (
  <FilterFilled style={{ color: filtered ? "#1677ff" : undefined }} />
);

// Filtre texte : "contient"
const textFilter = (placeholder, getValue) => ({
  filterDropdown: ({ selectedKeys, setSelectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        autoFocus
        placeholder={placeholder}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => confirm()}
        style={{ display: "block", marginBottom: 8, width: 210 }}
      />
      <Space>
        <Button
          type="primary"
          size="small"
          icon={<SearchOutlined />}
          onClick={() => confirm()}
        >
          Filtrer
        </Button>
        <Button
          size="small"
          onClick={() => {
            clearFilters && clearFilters();
            confirm();
          }}
        >
          Réinitialiser
        </Button>
      </Space>
    </div>
  ),
  filterIcon,
  onFilter: (value, record) => norm(getValue(record)).includes(norm(value)),
});

// Filtre intervalle (nombres ou dates). La valeur est stockée sous la forme "min|max"
const rangeFilter = (getValue, { date = false } = {}) => ({
  filterDropdown: ({ selectedKeys, setSelectedKeys, confirm, clearFilters }) => {
    const [a = "", b = ""] = String(selectedKeys[0] || "").split("|");
    const update = (min, max) =>
      setSelectedKeys(min || max ? [`${min}|${max}`] : []);
    return (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Space direction="vertical" size={6} style={{ display: "flex" }}>
          <Input
            type={date ? "date" : "number"}
            placeholder={date ? "Du" : "Min"}
            value={a}
            onChange={(e) => update(e.target.value, b)}
            style={{ width: 180 }}
          />
          <Input
            type={date ? "date" : "number"}
            placeholder={date ? "Au" : "Max"}
            value={b}
            onChange={(e) => update(a, e.target.value)}
            style={{ width: 180 }}
          />
          <Space>
            <Button type="primary" size="small" onClick={() => confirm()}>
              Filtrer
            </Button>
            <Button
              size="small"
              onClick={() => {
                clearFilters && clearFilters();
                confirm();
              }}
            >
              Réinitialiser
            </Button>
          </Space>
        </Space>
      </div>
    );
  },
  filterIcon,
  onFilter: (value, record) => {
    const [a = "", b = ""] = String(value).split("|");
    const v = getValue(record);
    if (v === null || v === undefined || v === "") return false;
    if (date) {
      const s = String(v);
      return (!a || s >= a) && (!b || s <= b);
    }
    const n = Number(v);
    return (a === "" || n >= Number(a)) && (b === "" || n <= Number(b));
  },
});

export default function CaissePreview() {
  const [tab, setTab] = useState("dashboard");
  const [showAddModal, setShowAddModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [caisses, setCaisses] = useState([]);
  const [caisseId, setCaisseId] = useState(null);
  const [agenceId, setAgenceId] = useState(null);
  const [departements, setDepartements] = useState([]);
  const [modesPaiement, setModesPaiement] = useState([]);
  const [refLoading, setRefLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [caissesRes, deptRes, modesRes] = await Promise.all([
          getCaisses(),
          getDepartements(),
          getModesPaiement(),
        ]);
        setCaisses(caissesRes.data);
        setDepartements(deptRes.data);
        setModesPaiement(modesRes.data);
        if (caissesRes.data.length) setCaisseId(caissesRes.data[0].id);
        if (caissesRes.data.length) setAgenceId(caissesRes.data[0].agence_id);
      } catch (e) {
        message.error(
          e.message || "Erreur lors du chargement des données de référence",
        );
      } finally {
        setRefLoading(false);
      }
    })();
  }, []);

  const caisse = caisses.find((c) => c.id === caisseId);

  return (
    <Layout className="caisse-app">
      <style>{GLOBAL_STYLES}</style>

      <Header
        className="app-header px-3 d-flex align-items-center justify-content-between"
        style={{ height: 64, lineHeight: "normal" }}
      >
        <div className="d-flex align-items-center gap-2">
          <div className="brand-badge">
            <i className="bi bi-bank2"></i>
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: "#1f2430" }}>
              Gestion de Caisse
            </div>
            <div className="text-secondary" style={{ fontSize: 12 }}>
              Suivi interne des mouvements
            </div>
          </div>
        </div>
        <div className="header-actions d-flex align-items-center gap-2 flex-wrap">
          <Select
            loading={refLoading}
            value={caisseId}
            onChange={setCaisseId}
            style={{ width: 220, maxWidth: "100%" }}
            options={caisses.map((c) => ({ value: c.id, label: c.nom }))}
            placeholder="Sélectionner une caisse"
          />
          <Button
            type="primary"
            disabled={!caisseId}
            icon={<i className="bi bi-plus-lg me-1"></i>}
            onClick={() => setShowAddModal(true)}
          >
            Nouveau mouvement
          </Button>
        </div>
      </Header>

      <div className="app-scroll">
        <div className="app-shell w-100 px-3">
          <Tabs
            activeKey={tab}
            onChange={setTab}
            items={[
              {
                key: "dashboard",
                label: (
                  <span>
                    <i className="bi bi-grid-1x2 me-1"></i>Tableau de bord
                  </span>
                ),
              },
              {
                key: "mouvements",
                label: (
                  <span>
                    <i className="bi bi-funnel me-1"></i>Mouvements
                  </span>
                ),
              },
              {
                key: "departements",
                label: (
                  <span>
                    <i className="bi bi-building me-1"></i>Départements
                  </span>
                ),
              },
            ]}
          />

          <Content className="pb-5">
            {!caisseId ? (
              <Empty
                className="pt-5"
                description={
                  refLoading ? "Chargement..." : "Aucune caisse disponible"
                }
              />
            ) : (
              <>
                {tab === "dashboard" && (
                  <DashboardTab
                    caisseId={caisseId}
                    caisseNom={caisse ? caisse.nom : ""}
                    refreshKey={refreshKey}
                  />
                )}
                {tab === "mouvements" && (
                  <MouvementsTab
                    caisseId={caisseId}
                    departements={departements}
                    modesPaiement={modesPaiement}
                    refreshKey={refreshKey}
                  />
                )}
                {tab === "departements" && (
                  <DepartementsTab
                    caisseId={caisseId}
                    departements={departements}
                    setDepartements={setDepartements}
                    agence_id={agenceId}
                    onDeptChanged={() => setRefreshKey((k) => k + 1)}
                  />
                )}
              </>
            )}
          </Content>
        </div>
      </div>

      {showAddModal && (
        <AddMovementModal
          caisseId={caisseId}
          departements={departements}
          modesPaiement={modesPaiement}
          onClose={() => setShowAddModal(false)}
          onSaved={() => {
            setShowAddModal(false);
            // Déclenche le refetch du dashboard + de la liste des mouvements,
            // sans avoir besoin de recharger la page.
            setRefreshKey((k) => k + 1);
          }}
        />
      )}
    </Layout>
  );
}

// ---------------------------------------------------------------------
// Dashboard
// ---------------------------------------------------------------------

function Kpi({ icon, label, value, tone }) {
  const tones = {
    blue: { bg: "#eaf2ff", color: "#1677ff" },
    green: { bg: "#e9f9ef", color: "#16a34a" },
    red: { bg: "#fdeeee", color: "#dc2626" },
    slate: { bg: "#f1f3f7", color: "#475569" },
  };
  const t = tones[tone];
  return (
    <Card size="small">
      <div className="d-flex align-items-center gap-3">
        <div className="kpi-icon" style={{ background: t.bg, color: t.color }}>
          <i className={"bi " + icon}></i>
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            className="text-secondary"
            style={{ fontSize: 12, fontWeight: 500 }}
          >
            {label}
          </div>
          <div style={{ fontSize: 18, fontWeight: 600, whiteSpace: "nowrap" }}>
            {value}
          </div>
        </div>
      </div>
    </Card>
  );
}

function DashboardTab({ caisseId, caisseNom, refreshKey }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getDashboard(caisseId);
      setData(res.data);
    } catch (e) {
      message.error(
        e.message || "Erreur lors du chargement du tableau de bord",
      );
    } finally {
      setLoading(false);
    }
    // refreshKey déclenche un rechargement après un ajout de mouvement/département
    // ailleurs dans l'app, sans que caisseId n'ait changé.
  }, [caisseId, refreshKey]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading || !data) {
    return (
      <div className="pt-5 text-center text-secondary">
        Chargement du tableau de bord...
      </div>
    );
  }

  const { kpis, soldeSeries, depensesParDepartement, derniersMouvements } =
    data;
  const maxDepense = Math.max(1, ...depensesParDepartement.map((d) => d.total));

  const columns = [
    { title: "Date", dataIndex: "date", render: (d) => fmtDate(d), width: 110 },
    { title: "Libellé", dataIndex: "libelle", ellipsis: true, width: 220 },
    {
      title: "Département",
      dataIndex: "departement",
      render: (v) => <Tag>{v}</Tag>,
      width: 150,
    },
    {
      title: "Solde",
      dataIndex: "solde",
      align: "right",
      render: (v) => <b>{fmt(v)}</b>,
      width: 150,
    },
  ];

  return (
    <div className="d-flex flex-column gap-3 pt-3">
      <div>
        <div style={{ fontSize: 16, fontWeight: 600 }}>{caisseNom}</div>
        <div
          className="text-secondary"
          style={{ fontSize: 12, textTransform: "capitalize" }}
        >
          {monthLabel(new Date())}
        </div>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={12} sm={12} md={6}>
          <Kpi
            icon="bi-wallet2"
            label="Solde actuel"
            value={fmt(kpis.soldeActuel)}
            tone="blue"
          />
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Kpi
            icon="bi-graph-up-arrow"
            label="Recettes du mois"
            value={fmt(kpis.recettes)}
            tone="green"
          />
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Kpi
            icon="bi-graph-down-arrow"
            label="Dépenses du mois"
            value={fmt(kpis.depenses)}
            tone="red"
          />
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Kpi
            icon="bi-list-check"
            label="Mouvements ce mois"
            value={kpis.count}
            tone="slate"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={16}>
          <Card
            title="Évolution du solde"
            size="small"
            extra={
              <span className="text-secondary" style={{ fontSize: 12 }}>
                Mois en cours
              </span>
            }
          >
            <SoldeAreaChart data={soldeSeries} />
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card
            title="Dépenses par département"
            size="small"
            extra={
              <span className="text-secondary" style={{ fontSize: 12 }}>
                Mois en cours
              </span>
            }
          >
            {depensesParDepartement.length === 0 && (
              <Empty description="Aucune dépense" />
            )}
            {depensesParDepartement.map((d) => (
              <div key={d.id} className="mb-2">
                <div
                  className="d-flex justify-content-between"
                  style={{ fontSize: 12 }}
                >
                  <span>{d.nom}</span>
                  <span className="text-secondary">{fmt(d.total)}</span>
                </div>
                <Progress
                  percent={Math.round((d.total / maxDepense) * 100)}
                  showInfo={false}
                  strokeColor={d.couleur}
                  size="small"
                />
              </div>
            ))}
          </Card>
        </Col>
      </Row>

      <Card title="Derniers mouvements" size="small">
        <Table
          dataSource={derniersMouvements}
          columns={columns}
          rowKey="id"
          size="small"
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </Card>
    </div>
  );
}

// ---------------------------------------------------------------------
// Mouvements
// ---------------------------------------------------------------------

const today = new Date();
const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const DEFAULT_FILTERS = {
  from: fmtDateInput(firstOfMonth),
  to: fmtDateInput(today),
  departement_id: null,
  mode_paiement_id: null,
  type: null,
  q: "",
  page: 1,
};

function MouvementsTab({
  caisseId,
  departements,
  modesPaiement,
  agence_id,
  refreshKey,
}) {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [attachMvt, setAttachMvt] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);
  const [downloadingMonth, setDownloadingMonth] = useState(false);
  const [exporting, setExporting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getMouvements({
        caisse_id: caisseId,
        du: filters.from,
        au: filters.to,
        departement_id: filters.departement_id || undefined,
        mode_paiement_id: filters.mode_paiement_id || undefined,
        type: filters.type || undefined,
        q: filters.q || undefined,
        page: filters.page,
        page_size: 10,
      });
      setRows(res.data);
      setTotal(res.pagination.total);
    } catch (e) {
      message.error(e.message || "Erreur lors du chargement des mouvements");
    } finally {
      setLoading(false);
    }
  }, [caisseId, filters]);

  useEffect(() => {
    const t = setTimeout(load, filters.q ? 350 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    caisseId,
    filters.from,
    filters.to,
    filters.departement_id,
    filters.mode_paiement_id,
    filters.type,
    filters.page,
    filters.q,
    refreshKey, // recharge la liste après un ajout de mouvement ailleurs dans l'app
  ]);

  const setFilter = (patch) =>
    setFilters((f) => ({ ...f, ...patch, page: patch.page ?? 1 }));

  const handleDelete = async (id) => {
    try {
      await deleteMouvement(id);
      message.success("Mouvement supprimé");
      load();
    } catch (e) {
      message.error(e.message || "Erreur lors de la suppression");
    }
  };

  // Déclenche le téléchargement d'un blob, en récupérant le nom de fichier
  // depuis l'en-tête Content-Disposition si le serveur le fournit
  const triggerBlobDownload = (blob, res, fallbackName) => {
    const disposition = res.headers.get("Content-Disposition") || "";
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match ? match[1] : fallbackName;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const downloadMouvementAttachments = async (mouvementId) => {
    setDownloadingId(mouvementId);
    try {
      const response = await exportMouvementPj(mouvementId);

      const disposition = response.headers["content-disposition"];
      let filename = `mouvement-${mouvementId}-pj.zip`;
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // Le backend renvoie du JSON (status 404/500) même si on attend un blob ;
      // axios ne le parse pas automatiquement en mode "blob", d'où ce petit
      // décodage manuel pour afficher un message d'erreur lisible.
      let description = "Erreur lors du téléchargement des pièces jointes";
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const parsed = JSON.parse(text);
          description = parsed.description || description;
        } catch (_) {
          // le corps n'était pas du JSON exploitable, on garde le message par défaut
        }
      }
      message.error(description);
    } finally {
      setDownloadingId(null);
    }
  };

  const exportMouvements = async (format = "xlsx") => {
    setExporting(true);
    try {
      const params = {
        caisse_id: caisseId,
        du: filters.from,
        au: filters.to,
        format: format,
      };

      if (filters.departement_id) {
        params.departement_id = filters.departement_id;
      }
      if (filters.mode_paiement_id) {
        params.mode_paiement_id = filters.mode_paiement_id;
      }
      if (filters.type) {
        params.type = filters.type;
      }
      if (filters.q) {
        params.q = filters.q;
      }

      const response = await exportMouvementsApi(params);

      // Récupère le nom de fichier envoyé par le back (Content-Disposition)
      const disposition = response.headers["content-disposition"];
      let filename = `export_depenses_${filters.from}_au_${filters.to}.zip`;
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      // Déclenche le téléchargement dans le navigateur
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Export généré avec succès");
    } catch (err) {
      message.error(err.message || "Erreur lors de l'export des mouvements");
    } finally {
      setExporting(false);
    }
  };

  const totalRecette = rows
    .filter((m) => m.type === "recette")
    .reduce((s, m) => s + (Number(m.montant) || 0), 0);

  const totalDepense = rows
    .filter((m) => m.type === "depense")
    .reduce((s, m) => s + (Number(m.montant) || 0), 0);

  // Catégories présentes dans les lignes chargées (pour le filtre de colonne)
  const categoriesOptions = useMemo(
    () =>
      Array.from(new Set(rows.map((r) => r.categorie).filter(Boolean))).map(
        (c) => ({ value: c, label: c }),
      ),
    [rows],
  );

  // Les filtres Département et Mode sont envoyés au serveur (donc valables
  // sur toutes les pages) ; les autres filtres de colonnes s'appliquent
  // aux lignes de la page affichée.
  const handleTableChange = (_pagination, tableFilters, _sorter, extra) => {
    if (extra?.action !== "filter") return;
    const modeVal = tableFilters.mode?.[0];
    if ((modeVal ?? null) !== (filters.mode_paiement_id ?? null)) {
      setFilter({ mode_paiement_id: modeVal ?? null });
    }
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      width: 80,
      render: (v) => <Typography.Text type="secondary">#{v}</Typography.Text>,
      ...textFilter("Id", (r) => r.id),
    },
    {
      title: "Date",
      dataIndex: "date",
      width: 125,
      render: (d) => (
        <Space size={6}>
          <CalendarOutlined style={{ color: "#8c8c8c" }} />
          {fmtDate(d)}
        </Space>
      ),
      ...rangeFilter((r) => (r.date ? fmtDateInput(r.date) : null), {
        date: true,
      }),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      ellipsis: { showTitle: false },
      width: 240,
      render: (v) => (
        <Tooltip placement="topLeft" title={v}>
          <span style={{ fontWeight: 500 }}>{v}</span>
        </Tooltip>
      ),
      ...textFilter("Libellé", (r) => r.libelle),
    },
    {
      title: "Référence",
      dataIndex: "reference",
      width: 170,
      render: (v, r) => (
        <div style={{ lineHeight: 1.35 }}>
          <div style={{ fontWeight: 600 }}>{v || r.ref_piece || "—"}</div>
          {v && r.ref_piece && (
            <Tag
              bordered={false}
              style={{
                marginTop: 2,
                fontSize: 11,
                color: "#8c8c8c",
                background: "#f5f5f5",
              }}
            >
              {r.ref_piece}
            </Tag>
          )}
        </div>
      ),
      ...textFilter("Référence ou réf. pièce", (r) =>
        `${r.reference || ""} ${r.ref_piece || ""}`,
      ),
    },
    {
      title: "Département / Catégorie",
      key: "dept_cat",
      width: 190,
      render: (_, r) => (
        <div style={{ lineHeight: 1.4 }}>
          {r.departement ? (
            <Tag
              color={colorFromText(r.departement)}
              style={{ borderRadius: 12, padding: "0 10px", marginRight: 0 }}
            >
              {r.departement}
            </Tag>
          ) : (
            <Typography.Text type="secondary">—</Typography.Text>
          )}
          {r.categorie && (
            <div style={{ marginTop: 4 }}>
              <Tag
                color="blue"
                bordered={false}
                style={{ borderRadius: 12, marginRight: 0 }}
              >
                {r.categorie}
              </Tag>
            </div>
          )}
        </div>
      ),
      // Département : filtre serveur (immédiat). Catégorie : filtre sur la page.
      filterDropdown: ({
        selectedKeys,
        setSelectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 240 }}>
          <Space direction="vertical" size={8} style={{ display: "flex" }}>
            <Select
              allowClear
              showSearch
              optionFilterProp="label"
              placeholder="Département"
              style={{ width: "100%" }}
              value={filters.departement_id ?? undefined}
              onChange={(v) => setFilter({ departement_id: v ?? null })}
              options={departements.map((d) => ({
                value: d.id,
                label: d.nom,
              }))}
              getPopupContainer={(t) => t.parentNode}
            />
            <Select
              allowClear
              showSearch
              placeholder="Catégorie (page affichée)"
              style={{ width: "100%" }}
              value={selectedKeys[0]}
              onChange={(v) => setSelectedKeys(v ? [v] : [])}
              options={categoriesOptions}
              getPopupContainer={(t) => t.parentNode}
            />
            <Space>
              <Button type="primary" size="small" onClick={() => confirm()}>
                OK
              </Button>
              <Button
                size="small"
                onClick={() => {
                  clearFilters && clearFilters();
                  setFilter({ departement_id: null });
                  confirm();
                }}
              >
                Réinitialiser
              </Button>
            </Space>
          </Space>
        </div>
      ),
      filterIcon: (filtered) =>
        filterIcon(filtered || !!filters.departement_id),
      onFilter: (value, r) => r.categorie === value,
    },
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
      width: 140,
      render: (v) => {
        if (!v) return "—";
        const { color, icon } = modeMeta(v);
        return (
          <Tag color={color} icon={icon}>
            {v}
          </Tag>
        );
      },
      // Filtre serveur : géré via handleTableChange
      filters: modesPaiement.map((m) => ({ text: m.nom, value: m.id })),
      filterMultiple: false,
      filteredValue:
        filters.mode_paiement_id != null ? [filters.mode_paiement_id] : null,
    },
    {
      title: "Recette",
      dataIndex: "montant",
      align: "right",
      width: 150,
      render: (v, r) =>
        r.type === "recette" ? (
          <Tag
            color="success"
            icon={<ArrowDownOutlined />}
            style={{ fontWeight: 600, fontSize: 13, marginRight: 0 }}
          >
            {fmt(v)}
          </Tag>
        ) : (
          <Typography.Text type="secondary">—</Typography.Text>
        ),
      ...rangeFilter((r) => (r.type === "recette" ? r.montant : null)),
    },
    {
      title: "Dépense",
      dataIndex: "montant",
      key: "depense",
      align: "right",
      width: 150,
      render: (v, r) =>
        r.type === "depense" ? (
          <Tag
            color="error"
            icon={<ArrowUpOutlined />}
            style={{ fontWeight: 600, fontSize: 13, marginRight: 0 }}
          >
            {fmt(v)}
          </Tag>
        ) : (
          <Typography.Text type="secondary">—</Typography.Text>
        ),
      ...rangeFilter((r) => (r.type === "depense" ? r.montant : null)),
    },
    {
      title: "Solde",
      dataIndex: "solde",
      align: "right",
      width: 150,
      render: (v) => (
        <b
          style={{ color: Number(v) < 0 ? "#dc2626" : "#0f172a", fontSize: 14 }}
        >
          {fmt(v)}
        </b>
      ),
      ...rangeFilter((r) => r.solde),
    },
    {
      title: "",
      key: "actions",
      align: "right",
      fixed: "right",
      width: 90,
      render: (_, r) => (
        <Space size={0}>
          <Tooltip title="Rattacher une pièce jointe">
            <Button
              size="small"
              type="text"
              icon={<PaperClipOutlined />}
              onClick={() => setAttachMvt(r)}
            />
          </Tooltip>
          <Tooltip title="Télécharger les pièces jointes">
            <Button
              size="small"
              type="text"
              icon={<DownloadOutlined />}
              loading={downloadingId === r.id}
              onClick={() => downloadMouvementAttachments(r.id)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div className="d-flex flex-column gap-3 pt-3">
      <Card
        size="small"
        title={
          <span>
            <i className="bi bi-funnel me-2"></i>Filtrer les mouvements
          </span>
        }
      >
        <Row gutter={[12, 12]}>
          <Col xs={12} sm={8} md={4}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Du
            </div>

            <DatePicker
              style={{ width: "100%", height: 32 }}
              value={moment(filters.from)}
              format="YYYY-MM-DD"
              onChange={(d) =>
                setFilter({
                  from: d ? d.format("YYYY-MM-DD") : null,
                })
              }
            />
          </Col>
          <Col xs={12} sm={8} md={4}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Au
            </div>
            <DatePicker
              style={{ width: "100%", height: 32 }}
              value={moment(filters.to)}
              onChange={(d) =>
                setFilter({ to: d ? d.format("YYYY-MM-DD") : filters.to })
              }
            />
          </Col>
          <Col xs={24} sm={8} md={5}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Département
            </div>
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Tous"
              value={filters.departement_id}
              onChange={(v) => setFilter({ departement_id: v ?? null })}
              options={departements.map((d) => ({ value: d.id, label: d.nom }))}
            />
          </Col>
          <Col xs={12} sm={8} md={4}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Mode
            </div>
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Tous"
              value={filters.mode_paiement_id}
              onChange={(v) => setFilter({ mode_paiement_id: v ?? null })}
              options={modesPaiement.map((m) => ({
                value: m.id,
                label: m.nom,
              }))}
            />
          </Col>
          <Col xs={12} sm={8} md={3}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Type
            </div>
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Tous"
              value={filters.type}
              onChange={(v) => setFilter({ type: v ?? null })}
              options={TYPES_MOUVEMENT}
            />
          </Col>
          <Col xs={24} sm={16} md={4}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Recherche
            </div>
            <Input
              className="movement-search"
              placeholder="Libellé..."
              allowClear
              prefix={<i className="bi bi-search text-secondary"></i>}
              value={filters.q}
              onChange={(e) => setFilter({ q: e.target.value })}
            />
          </Col>
        </Row>
      </Card>

      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div className="d-flex gap-3 flex-wrap">
          <span className="text-secondary">{total} mouvement(s)</span>
          <span style={{ color: "#16a34a", fontWeight: 500 }}>
            + {fmt(totalRecette)}
          </span>
          <span style={{ color: "#dc2626", fontWeight: 500 }}>
            − {fmt(totalDepense)}
          </span>
        </div>
        <Space>
          <Button
            icon={<i className="bi bi-download me-1"></i>}
            loading={exporting}
            onClick={() => exportMouvements("xlsx")}
          >
            Exporter (Excel / PDF)
          </Button>
        </Space>
      </div>

      <Card size="small">
        <Table
          dataSource={rows}
          columns={columns}
          rowKey="id"
          size="middle"
          scroll={{ x: "max-content" }}
          loading={loading}
          rowClassName={(r) =>
            r.type === "depense" ? "row-depense" : "row-recette"
          }
          onChange={handleTableChange}
          pagination={{
            current: filters.page,
            pageSize: 10,
            total,
            showSizeChanger: false,
            onChange: (page) => setFilter({ page }),
          }}
        />
      </Card>

      {attachMvt && (
        <AttachmentModal
          mouvement={attachMvt}
          onClose={() => setAttachMvt(null)}
          onSaved={() => {
            setAttachMvt(null);
            load();
          }}
        />
      )}
    </div>
  );
}

function AttachmentModal({ mouvement, onClose, onSaved }) {
  const [fileList, setFileList] = useState([]); // éléments { uid, name, url (objectURL), file }
  const [saving, setSaving] = useState(false);

  // Nettoie les URL objets créées pour la prévisualisation, pour éviter les fuites mémoire
  useEffect(() => {
    return () => {
      fileList.forEach((f) => f.url && URL.revokeObjectURL(f.url));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addFiles = (newFiles) => {
    const mapped = newFiles.map((file) => ({
      uid: `${file.name}-${file.lastModified}-${Math.random().toString(36).slice(2)}`,
      name: file.name,
      url: URL.createObjectURL(file),
      file,
    }));
    setFileList((prev) => [...prev, ...mapped]);
  };

  // beforeUpload renvoyant false empêche antd d'envoyer le fichier tout seul :
  // on garde la main sur l'upload final (voir submit()).
  const beforeUpload = (file, allFiles) => {
    addFiles(allFiles);
    return false;
  };

  const removeFile = (uid) => {
    setFileList((prev) => {
      const target = prev.find((f) => f.uid === uid);
      if (target?.url) URL.revokeObjectURL(target.url);
      return prev.filter((f) => f.uid !== uid);
    });
  };

  const submit = async () => {
    if (!fileList.length) {
      message.warning("Ajoute au moins une image avant d'enregistrer");
      return;
    }
    setSaving(true);
    try {
      const formData = new FormData();
      fileList.forEach((f) => formData.append("pj", f.file));

      // NOTE : adapte cet appel si la signature réelle de addpj diffère
      // (ex : addpj(formData) avec mouvement_id déjà inclus dedans).
      await addpj(mouvement.id, formData);

      message.success("Pièce(s) jointe(s) enregistrée(s)");
      onSaved();
    } catch (e) {
      message.error(
        e.response?.data?.description ||
          e.response?.data?.message ||
          e.message ||
          "Erreur lors de l'envoi des pièces jointes",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={true}
      onCancel={onClose}
      title={
        <span>
          <PaperClipOutlined className="me-2" />
          Pièces jointes — {mouvement.libelle}
        </span>
      }
      width="min(520px, 92vw)"
      footer={[
        <Button key="cancel" onClick={onClose}>
          Annuler
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={saving}
          disabled={!fileList.length}
          icon={<i className="bi bi-check-lg me-1"></i>}
          onClick={submit}
        >
          Enregistrer
        </Button>,
      ]}
    >
      <div className="pt-2">
        <div className="attach-actions">
          {/* capture="environment" = ouvre directement la caméra arrière sur mobile */}
          <Upload
            accept="image/*"
            capture="environment"
            multiple={false}
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file, [file])}
          >
            <Button icon={<CameraOutlined />} block>
              Prendre une photo
            </Button>
          </Upload>

          <Upload
            accept="image/*"
            multiple
            showUploadList={false}
            beforeUpload={(file, allFiles) => beforeUpload(file, allFiles)}
          >
            <Button icon={<UploadOutlined />} block>
              Choisir des fichiers
            </Button>
          </Upload>
        </div>

        {fileList.length === 0 ? (
          <Empty
            className="pt-4"
            image={
              <FileImageOutlined style={{ fontSize: 32, color: "#c1c7d0" }} />
            }
            description="Aucune pièce jointe sélectionnée"
          />
        ) : (
          <div className="attach-preview-grid">
            {fileList.map((f) => (
              <div className="attach-preview-item" key={f.uid}>
                <img src={f.url} alt={f.name} />
                <button
                  type="button"
                  className="attach-preview-remove"
                  onClick={() => removeFile(f.uid)}
                  title="Retirer"
                >
                  <DeleteOutlined />
                </button>
                <div className="attach-preview-name">{f.name}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}

// ---------------------------------------------------------------------
// Départements
// ---------------------------------------------------------------------

function DepartementsTab({
  caisseId,
  departements,
  setDepartements,
  agence_id,
  onDeptChanged,
}) {
  const [form, setForm] = useState({
    nom: "",
    code: "",
    responsable: "",
    couleur: "#1677ff",
  });
  const [saving, setSaving] = useState(false);
  const [spendByDept, setSpendByDept] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const res = await getDashboard(caisseId);
        const map = {};
        res.data.depensesParDepartement.forEach((d) => {
          map[d.nom] = d.total;
        });
        setSpendByDept(map);
      } catch (e) {
        // Non bloquant pour cet onglet
      }
    })();
  }, [caisseId, departements]);

  const addDept = async () => {
    if (!form.nom.trim()) {
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        agence_id: agence_id,
      };
      const res = await createDepartement(payload);
      setDepartements((prev) => [...prev, res.data]);

      setForm({
        nom: "",
        code: "",
        responsable: "",
        couleur: "#1677ff",
      });

      message.success("Département ajouté");
      onDeptChanged?.();
    } catch (e) {
      message.error(e.message || "Erreur lors de la création du département");
    } finally {
      setSaving(false);
    }
  };

  const removeDept = async (id) => {
    try {
      await deleteDepartement(id);
      setDepartements((prev) => prev.filter((x) => x.id !== id));
      onDeptChanged?.();
    } catch (e) {
      message.error(
        e.message || "Erreur lors de la suppression du département",
      );
    }
  };

  return (
    <Row gutter={[20, 16]} className="pt-3">
      <Col xs={24} lg={16} className="d-flex flex-column gap-2">
        {departements.map((d) => (
          <Card key={d.id} size="small">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
              <div
                className="d-flex align-items-center gap-3"
                style={{ minWidth: 0 }}
              >
                <div className="dept-swatch" style={{ background: d.couleur }}>
                  {d.code}
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>{d.nom}</div>
                  <div className="text-secondary" style={{ fontSize: 12 }}>
                    Responsable : {d.responsable || "—"}
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center gap-4">
                <div className="text-end">
                  <div className="text-secondary" style={{ fontSize: 12 }}>
                    Dépenses (mois)
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#dc2626",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {fmt(spendByDept[d.nom] || 0)}
                  </div>
                </div>
                <Space>
                  <Button
                    size="small"
                    type="text"
                    icon={<i className="bi bi-pencil"></i>}
                  />
                  <Button
                    size="small"
                    type="text"
                    danger
                    icon={<i className="bi bi-trash"></i>}
                    onClick={() => removeDept(d.id)}
                  />
                </Space>
              </div>
            </div>
            <CategoriesDepartement departementId={d.id} />
          </Card>
        ))}
      </Col>

      <Col xs={24} lg={8}>
        <Card size="small" title="Ajouter un département">
          <div className="d-flex flex-column gap-2">
            <div>
              <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
                Nom
              </div>
              <Input
                value={form.nom}
                placeholder="Ex : Entretien"
                onChange={(e) =>
                  setForm((f) => ({ ...f, nom: e.target.value }))
                }
              />
            </div>
            <div>
              <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
                Code (3 lettres)
              </div>
              <Input
                value={form.code}
                placeholder="ETR"
                maxLength={4}
                onChange={(e) =>
                  setForm((f) => ({ ...f, code: e.target.value.toUpperCase() }))
                }
              />
            </div>
            <div>
              <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
                Responsable
              </div>
              <Input
                value={form.responsable}
                onChange={(e) =>
                  setForm((f) => ({ ...f, responsable: e.target.value }))
                }
              />
            </div>
            <div>
              <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
                Couleur
              </div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="color"
                  value={form.couleur}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, couleur: e.target.value }))
                  }
                  style={{
                    width: 40,
                    height: 32,
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    padding: 2,
                    cursor: "pointer",
                  }}
                />
                <Input
                  value={form.couleur}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, couleur: e.target.value }))
                  }
                  style={{ width: 110 }}
                />
              </div>
            </div>
            <Button
              type="primary"
              block
              loading={saving}
              icon={<i className="bi bi-plus-lg me-1"></i>}
              onClick={addDept}
            >
              Ajouter le département
            </Button>
          </div>
        </Card>
      </Col>
    </Row>
  );
}

// ---------------------------------------------------------------------
// Catégories d'un département
// ---------------------------------------------------------------------

function CategoriesDepartement({ departementId }) {
  const [categories, setCategories] = useState([]);
  const [nom, setNom] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await getCategories(departementId);
        setCategories(res.data || []);
      } catch (e) {
        message.error(e.message || "Erreur lors du chargement des catégories");
      }
    })();
  }, [departementId]);

  const add = async () => {
    if (!nom.trim()) return;
    setSaving(true);
    try {
      const res = await createCategorie(departementId, { nom: nom.trim() });
      setCategories((prev) => [...prev, res.data]);
      setNom("");
    } catch (e) {
      message.error(e.message || "Erreur lors de la création de la catégorie");
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    try {
      await deleteCategorie(id);
      setCategories((prev) => prev.filter((c) => c.id !== id));
    } catch (e) {
      message.error(e.message || "Erreur lors de la suppression");
    }
  };

  return (
    <div className="mt-2 pt-2" style={{ borderTop: "1px dashed #e8ecf3" }}>
      <div className="d-flex align-items-center flex-wrap gap-2">
        <span className="text-secondary" style={{ fontSize: 12 }}>
          Catégories :
        </span>
        {categories.length === 0 && (
          <span className="text-secondary" style={{ fontSize: 12 }}>
            aucune
          </span>
        )}
        {categories.map((c) => (
          <Tag
            key={c.id}
            closable
            onClose={(e) => {
              e.preventDefault();
              remove(c.id);
            }}
          >
            {c.nom}
          </Tag>
        ))}
        <Input
          size="small"
          style={{ width: 170 }}
          value={nom}
          placeholder="Nouvelle catégorie"
          onChange={(e) => setNom(e.target.value)}
          onPressEnter={add}
        />
        <Button
          size="small"
          loading={saving}
          onClick={add}
          icon={<i className="bi bi-plus-lg"></i>}
        />
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Modal ajout mouvement
// ---------------------------------------------------------------------

function AddMovementModal({
  caisseId,
  departements,
  modesPaiement,
  onClose,
  onSaved,
}) {
  const [saving, setSaving] = useState(false);
  const [categories, setCategories] = useState([]);

  const [form, setForm] = useState({
    date: fmtDateInput(new Date()),
    libelle: "",
    departement_id: departements[0] ? departements[0].id : null,
    mode_paiement_id: modesPaiement[0] ? modesPaiement[0].id : null,
    montant: null,
    type: "depense",
    pj: [],
  });

  useEffect(() => {
    if (!form.departement_id) {
      setCategories([]);
      return;
    }
    (async () => {
      try {
        const res = await getCategories(form.departement_id);
        setCategories(res.data || []);
      } catch (e) {
        setCategories([]);
      }
    })();
  }, [form.departement_id]);

  const submit = async () => {
    if (
      !form.libelle.trim() ||
      !form.montant ||
      !form.departement_id ||
      !form.mode_paiement_id
    ) {
      message.warning("Merci de remplir tous les champs");
      return;
    }

    setSaving(true);

    try {
      const formData = new FormData();
      formData.append("date", form.date);
      formData.append("libelle", form.libelle);
      formData.append("departement_id", form.departement_id);
      if (form.categorie_id) formData.append("categorie_id", form.categorie_id);
      formData.append("mode_paiement_id", form.mode_paiement_id);
      formData.append("montant", Number(form.montant));
      formData.append("type", form.type);
      formData.append("caisse_id", caisseId);
      // Ajouter les fichiers
      (form.pj || []).forEach((file) => {
        if (file.originFileObj) {
          formData.append("pj", file.originFileObj);
        }
      });
      await createMouvement(formData);
      message.success("Mouvement enregistré");
      onSaved();
    } catch (e) {
      message.error(
        e.response?.data?.message ||
          e.message ||
          "Erreur lors de l'enregistrement du mouvement",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={true}
      onCancel={onClose}
      title="Nouveau mouvement"
      width="min(520px, 92vw)"
      footer={[
        <Button key="cancel" onClick={onClose}>
          Annuler
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={saving}
          icon={<i className="bi bi-check-lg me-1"></i>}
          onClick={submit}
        >
          Enregistrer
        </Button>,
      ]}
    >
      <div className="d-flex flex-column gap-3 pt-2">
        <Row gutter={[12, 12]}>
          <Col xs={24} sm={12}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Type
            </div>
            <Select
              style={{ width: "100%" }}
              value={form.type}
              onChange={(v) => setForm((f) => ({ ...f, type: v }))}
              options={TYPES_MOUVEMENT}
            />
          </Col>
          <Col xs={24} sm={12}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Date
            </div>
            <DatePicker
              style={{ width: "100%", height: 32 }}
              value={moment(form.date)}
              onChange={(d) =>
                setForm((f) => ({
                  ...f,
                  date: d ? d.format("YYYY-MM-DD") : f.date,
                }))
              }
            />
          </Col>
        </Row>

        <div>
          <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
            Libellé
          </div>
          <Input
            value={form.libelle}
            placeholder="Ex : Fret camion 3947 AJ"
            onChange={(e) =>
              setForm((f) => ({ ...f, libelle: e.target.value }))
            }
          />
        </div>

        <Row gutter={[12, 12]}>
          <Col xs={24} sm={12}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Département
            </div>
            <Select
              style={{ width: "100%" }}
              value={form.departement_id}
              onChange={(v) =>
                setForm((f) => ({
                  ...f,
                  departement_id: v,
                  categorie_id: null,
                }))
              }
              options={departements.map((d) => ({ value: d.id, label: d.nom }))}
            />
          </Col>
          <Col xs={24} sm={12}>
            <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
              Mode de paiement
            </div>
            <Select
              style={{ width: "100%" }}
              value={form.mode_paiement_id}
              onChange={(v) => setForm((f) => ({ ...f, mode_paiement_id: v }))}
              options={modesPaiement.map((m) => ({
                value: m.id,
                label: m.nom,
              }))}
            />
          </Col>
        </Row>

        <div>
          <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
            Catégorie
          </div>
          <Select
            style={{ width: "100%" }}
            allowClear
            disabled={categories.length === 0}
            placeholder={
              categories.length === 0
                ? "Aucune catégorie pour ce département"
                : "Choisir une catégorie (optionnel)"
            }
            value={form.categorie_id}
            onChange={(v) =>
              setForm((f) => ({ ...f, categorie_id: v ?? null }))
            }
            options={categories.map((c) => ({ value: c.id, label: c.nom }))}
          />
        </div>

        <div>
          <div className="text-secondary mb-1" style={{ fontSize: 12 }}>
            Montant (Ar)
          </div>
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            value={form.montant}
            placeholder="0"
            formatter={(v) =>
              v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ") : ""
            }
            onChange={(v) => setForm((f) => ({ ...f, montant: v }))}
          />
        </div>
        <Row gutter={16}>
          <Col span={24}>
            <Row align="middle" gutter={8}>
              <Col span={5} style={{ textAlign: "center" }}>
                Pièces jointes
              </Col>

              <Col span={19}>
                <Upload
                  multiple
                  beforeUpload={() => false}
                  fileList={form.pj || []}
                  onChange={({ fileList }) => {
                    setForm((f) => ({
                      ...f,
                      pj: fileList,
                    }));
                  }}
                >
                  <Button icon={<UploadOutlined />}>
                    Ajouter des fichiers
                  </Button>
                </Upload>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Modal>
  );
}